<template>
    <v-row class="scan-table-heading">
        <v-col cols="12" sm="auto" class="scan-table-heading__count">
            {{tableHeading}}
        </v-col>
        <v-col v-if="!hasLocator" cols="12" sm="auto" class="scan-table-heading__message">
            Pending items will be automatically shelved to the next scanned destination locator
        </v-col>
    </v-row>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'ScanTableHeading',
    props: {
        locator: {
            type: Object,
            required: false,
            default: () => {},
        },
        scannedAmount: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    computed: {
        hasLocator() {
            return !_.isEmpty( this.locator );
        },
        scannedText() {
            switch ( this.scannedAmount ) {
                case 1:
                    return 'Scanned Item';
                default:
                    return 'Scanned Items';
            }
        },
        tableHeading() {
            return `${ this.scannedAmount || '' } ${ this.scannedText }${ !this.hasLocator ? ':' : '' }`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .scan-table-heading {
        font-size: 1.25rem;
        margin-top: 1rem;

        &__count {
            padding: 0 12px;
        }
        &__message {
            padding: 0 12px;
            font-size: 1rem;
            margin: 4px 0 8px;
        }
    }
</style>
